<template>
	<div class="audiosnippet">
		<span ref='snippet' :data-sound="src" >
		<figure class='icon-soundquote' v-if='show'>
			<svg width="82px" height="84px" viewBox="0 0 82 84" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Group 12 Copy</title>
    <defs>
        <polygon id="path-1" points="0 0.384702128 81.5953478 0.384702128 81.5953478 83.9995532 0 83.9995532"></polygon>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Desktop-HD" transform="translate(-406.000000, -3294.000000)">
            <g id="Group-12-Copy" transform="translate(406.000000, 3294.000000)">
                <g id="Group-3">
                    <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                    </mask>
                    <g id="Clip-2"></g>
                    <path d="M69.6465217,71.754766 C53.7135652,88.0811489 27.8817826,88.0811489 11.9488261,71.754766 C-3.98413043,55.428383 -3.98413043,28.9558723 11.9488261,12.6294894 C27.8817826,-3.69689362 53.7135652,-3.69689362 69.6465217,12.6294894 C85.5794783,28.9558723 85.5794783,55.428383 69.6465217,71.754766" id="Fill-1" fill="#8456FF" mask="url(#mask-2)"></path>
                </g>
                <g id="Group-4" transform="translate(30.000000, 30.000000)" fill="#000000">
                    <path d="M17.0267497,7.91764706 C16.8244168,8.12156863 16.8244168,8.4519971 17.0267497,8.65780683 C18.0021474,9.6453159 18.5404295,10.957589 18.5404295,12.3529412 C18.5404295,13.7482934 18.0021474,15.0624546 17.0267497,16.0499637 C16.8244168,16.2538853 16.8244168,16.5843137 17.0267497,16.7882353 C17.1279162,16.8901961 17.2596235,16.9411765 17.3913309,16.9411765 C17.524947,16.9411765 17.6566543,16.8901961 17.7578208,16.7882353 C18.929825,15.6043573 19.575,14.0277415 19.575,12.3529412 C19.575,10.6781409 18.929825,9.10152505 17.7578208,7.91764706 C17.5554878,7.71372549 17.2271739,7.71372549 17.0267497,7.91764706" id="Fill-4"></path>
                    <path d="M20.3377352,5.09141494 C20.1629245,4.89109698 19.8809186,4.89109698 19.706108,5.09141494 C19.5312973,5.29173291 19.5312973,5.618177 19.706108,5.81849497 C22.8411556,9.42050874 22.8411556,15.2853736 19.706108,18.8873874 C19.5312973,19.0895601 19.5312973,19.4141494 19.706108,19.6144674 C19.7935133,19.7146264 19.9073052,19.7647059 20.0227462,19.7647059 C20.1348888,19.7647059 20.2503298,19.7146264 20.3377352,19.6144674 C23.8207549,15.6099629 23.8207549,9.09591945 20.3377352,5.09141494" id="Fill-6"></path>
                    <path d="M23.0893516,2.26670474 C22.9044718,2.06796117 22.601621,2.06796117 22.4149804,2.26670474 C22.2283399,2.46544832 22.2283399,2.78748652 22.4149804,2.98807031 C24.7567915,5.48892696 26.0474287,8.81420141 26.0474287,12.3529412 C26.0474287,15.8916809 24.7567915,19.2169554 22.4149804,21.7196523 C22.2283399,21.9183958 22.2283399,22.240434 22.4149804,22.4391776 C22.5083007,22.5385494 22.6297932,22.5882353 22.7530464,22.5882353 C22.8745388,22.5882353 22.9960313,22.5385494 23.0893516,22.4391776 C25.612521,19.745098 27,16.1640333 27,12.3529412 C27,8.54368932 25.612521,4.96078431 23.0893516,2.26670474" id="Fill-8"></path>
                    <path d="M15.2634735,0.0570469172 C15.1040498,-0.0296440195 14.9088006,-0.0170015912 14.7601246,0.0913620797 L5.18395639,7.00135216 L0.485436137,7.00135216 C0.216744548,7.00135216 0,7.22349769 0,7.49982505 L0,16.4994279 C0,16.7757553 0.216744548,16.9997069 0.485436137,16.9997069 L5.18395639,16.9997069 L14.7601246,23.9096969 C14.8443146,23.969297 14.9410436,24 15.0395639,24 C15.1165888,24 15.1918224,23.9819394 15.2634735,23.9440121 C15.4246885,23.8573212 15.525,23.6857454 15.525,23.4997211 L15.525,0.501337968 C15.525,0.315313666 15.4246885,0.143737854 15.2634735,0.0570469172" id="Fill-10"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
		</figure>

			<span class='sound-snippet'>
				<slot />
			</span>
		</span>
		<span class='sound-duration' ref='duration'></span>
	</div>
</template>

<script>
	import SoundSnippet from './sound-snippet';

	const vueObject = {
		props: ['src', 'show'],
		data: function() {
			return {
				duration: ''
			}
		},
		mounted: function() {
			this.render();
		},
		methods: {
			render() {
				let duration = this.show ? this.$refs.duration : '';
				let soundBlock = new SoundSnippet({el: this.$refs.snippet, durationEl: duration});
			}		
		}
	}

	export default vueObject;
</script>

<style lang="scss">
figure.icon-soundquote {
    display: inline-block;

		svg {
			width: 20px;
			margin-right: 1rem;
		}

	}
	.knd-sound-active {
		background: #E1E1E1;
		color: #28006D;
	}
</style>